import React, { useState, useEffect } from 'react'
import { AiOutlineClose, AiOutlineMenu } from 'react-icons/ai'
import { Link } from 'react-scroll'
import './Navbar.css'
import logo from '../assets/logo.png'

const Navbar = () => {
  const [nav, setNav] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  const handleNav = () => setNav(!nav)

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[9999] flex justify-between items-center h-20 px-6 transition-all duration-300 ${
        scrolled ? 'bg-black/90 backdrop-blur-sm shadow-lg' : 'bg-transparent'
      }`}
    >
      {/* Logo */}
      <div className='w-16 flex-shrink-0'>
        <img src={logo} alt='SpacePowerGym Logo' className='w-full' />
      </div>

      {/* Title */}
      <h1 className='logo hidden lg:block text-xl font-bold uppercase text-white tracking-wider cursor-pointer'>
        Space Power Gym
      </h1>

      {/* Desktop Nav */}
      <ul className='hidden md:flex items-center gap-6'>
        <li className='cursor-pointer text-gray-300 hover:text-white transition-colors text-sm font-medium'>
          <Link to='location' spy smooth offset={-80} duration={500}>Standort</Link>
        </li>
        <li className='cursor-pointer text-gray-300 hover:text-white transition-colors text-sm font-medium'>
          <Link to='mt' spy smooth offset={-80} duration={500}>Mitgliedschaft</Link>
        </li>
        <li className='cursor-pointer text-gray-300 hover:text-white transition-colors text-sm font-medium'>
          <Link to='pt' spy smooth offset={-80} duration={500}>Personal Training</Link>
        </li>
        <li className='cursor-pointer text-gray-300 hover:text-white transition-colors text-sm font-medium'>
          <Link to='shop' spy smooth offset={-80} duration={500}>Supplements</Link>
        </li>
        <li>
          <a
            href='https://spacepower.store'
            target='_blank'
            rel='noopener noreferrer'
            className='text-white font-bold text-sm px-5 py-2.5 rounded-lg transition-opacity hover:opacity-90 whitespace-nowrap'
            style={{background:'#cc2200'}}
          >
            Shop
          </a>
        </li>
      </ul>

      {/* Mobile Hamburger */}
      <div onClick={handleNav} className='block md:hidden cursor-pointer text-gray-400 hover:text-white'>
        {nav ? <AiOutlineClose size={28} /> : <AiOutlineMenu size={28} />}
      </div>

      {/* Mobile Menu */}
      <div className={`fixed left-0 top-0 w-[70%] max-w-[320px] h-full bg-gray-950 border-r border-gray-800 z-[9998] transition-transform duration-300 ease-in-out ${nav ? 'translate-x-0' : '-translate-x-full'}`}>
        <div className='p-6 border-b border-gray-800 flex items-center gap-3'>
          <img src={logo} alt='Logo' className='w-10' />
          <h1 className='text-lg font-bold text-white'>Space Power Gym</h1>
        </div>
        <ul className='p-4'>
          <li className='p-4 border-b border-gray-800 text-gray-300 hover:text-white cursor-pointer text-sm font-semibold tracking-wide' onClick={() => setNav(false)}>
            <Link to='location' spy smooth offset={-80} duration={500}>Standort</Link>
          </li>
          <li className='p-4 border-b border-gray-800 text-gray-300 hover:text-white cursor-pointer text-sm font-semibold tracking-wide' onClick={() => setNav(false)}>
            <Link to='mt' spy smooth offset={-80} duration={500}>Mitgliedschaft</Link>
          </li>
          <li className='p-4 border-b border-gray-800 text-gray-300 hover:text-white cursor-pointer text-sm font-semibold tracking-wide' onClick={() => setNav(false)}>
            <Link to='pt' spy smooth offset={-80} duration={500}>Personal Training</Link>
          </li>
          <li className='p-4 border-b border-gray-800 text-gray-300 hover:text-white cursor-pointer text-sm font-semibold tracking-wide' onClick={() => setNav(false)}>
            <Link to='shop' spy smooth offset={-80} duration={500}>Supplements</Link>
          </li>
          <li className='p-4'>
            <a
              href='https://spacepower.store'
              target='_blank'
              rel='noopener noreferrer'
              className='block text-white font-bold text-center py-3 rounded-lg'
              style={{background:'#cc2200'}}
            >
              SpacePower.Store
            </a>
          </li>
        </ul>
      </div>

      {/* Mobile overlay */}
      {nav && (
        <div className='fixed inset-0 bg-black/50 z-[9997]' onClick={() => setNav(false)} />
      )}
    </div>
  )
}

export default Navbar
